
<HeroSection
    :title="title"
    :title-highlight="titleHighlight"
    :subtitle="subtitle"
    :primary-action="primaryAction"
    :secondary-action="secondaryAction"
    :highlights="highlights"
    :overlay="true"
    :background-image="backgroundImage"
    :animate-title-words="true"
    :lang="'de'"
>
    <template #title>
        <span class="TitleHighlight">{{ titleHighlight }}</span>
        Ihr zuverlässiger Partner für moderne<br />
        Taxi- und Mietwagenverwaltung
    </template>
</HeroSection>
